import { Link, useLocation } from "react-router-dom";

const useBreadcrumbs = () => {
  const location = useLocation(); // Get current URL
  const pathnames = location.pathname.split("/").filter((x) => x); // Remove empty parts

  // Custom mapping for breadcrumb labels
  const breadcrumbMap = {
    resources: "Resource Centers",
    addResourceCenterRequest: "Add New Resource Center",
    register: "Create New Account",
    resourcesDetails: "Resource Center Details",
    requestSupport: "Request Support",
    submitFeedback: "Submit Feedback",
    isdbhistory: "IsDB History",
  };

  // Get the current path and title
  let currentPath = pathnames[pathnames.length - 1] || "";
  let currentTitle = breadcrumbMap[currentPath] || currentPath.replace("-", " ");
  if (pathnames.includes("addResourceCenterRequest") && pathnames.length > 1) {
    currentPath = "addResourceCenterRequest"; // Change last part to "resources"
    currentTitle = breadcrumbMap[currentPath] || currentPath.replace("-", " ");
  }
  else if(pathnames.includes("requestSupport")) {
    currentPath = "requestSupport"; // Change last part to "resources"
    currentTitle = breadcrumbMap["requestSupport"] || currentPath.replace("-", " ");
  }
  else if(pathnames.includes("submitFeedback")) {
    currentPath = "submitFeedback"; // Change last part to "resources"
    currentTitle = breadcrumbMap["submitFeedback"] || currentPath.replace("-", " ");
  }
  else if (pathnames.includes("resources") && pathnames.length > 1) {
    currentPath = "resourcesDetails"; // Change last part to "resources"
    currentTitle = breadcrumbMap["resourcesDetails"] || currentPath.replace("-", " ");
  }

  return { pathnames, breadcrumbMap, currentPath, currentTitle };
};

const Breadcrumbs = () => {
  const { pathnames, breadcrumbMap, currentPath } = useBreadcrumbs();
  if (currentPath === "register") { return null; } // Hide breadcrumbs on the register page
  return (
    <nav className="breadcrumbs">
      <ul className="breadcrumb banner-bredcrumb breadcrumb-section">
        <li>
          <Link to="/">Home <i className="icon-Path-1074"></i></Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isId = /^\d+$/.test(value) || /^[a-f0-9]{24}$/i.test(value);
          const label = breadcrumbMap[value] || (isId ? "Details" : value.replace("-", " "));

          return (
            <li key={to}>
              <Link to={to}>{label}</Link>
              {index < pathnames.length - 1 && <i className="icon-Path-1074"></i>}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

const NavigationBar = () => {
  const { currentTitle } = useBreadcrumbs();
  
  return (
    <div className="banner">
       <div className="container-fluid container-inner-pages">
    <div className="banner-title">
    <div className="breadcrumb-section-wrapper">
      <h2>{currentTitle}</h2>
      <ul className="">
        <li>
          <Breadcrumbs /> 
        </li>
      </ul>
   </div>
   </div>
    </div>
   
  </div>
  );
};

export default NavigationBar;
